// extracted by mini-css-extract-plugin
module.exports = {"footer":"FooterSocial_footer__sOxqS","inner":"FooterSocial_inner__eNWja","links":"FooterSocial_links__xEP3w"};